import React from 'react'
import { observer } from 'mobx-react-lite'
import { IconButton, layoutStore } from 'shared/ui'
import { useDiscoverContext } from 'pages/discover/context/context'
import styles from './styles.module.scss'

export const DiscoverMenuCollapseButton = observer(() => {
  const { isMobileViewWithoutMSize } = layoutStore
  const {
    pageLayoutStore: { titleIconProps, headerMenuTooltipIconProps, handleToggleCollapse },
  } = useDiscoverContext()

  if (!isMobileViewWithoutMSize) return null

  return (
    <div className={styles.collapseButtonContainer}>
      <IconButton
        iconProps={{
          fontSize: titleIconProps.fontSize,
          icon: titleIconProps.icon,
        }}
        tooltipProps={headerMenuTooltipIconProps}
        variant={'icon'}
        size={'medium'}
        color={'secondary'}
        onClick={handleToggleCollapse}
        ariaLabel='DiscoverMenuCollapseButton'
      />
    </div>
  )
})
